import moment from "moment-timezone";
import "moment/locale/ru";
// import "moment/locale/en";
import "moment/locale/et";
import "moment/locale/es";

moment.tz.setDefault("Europe/Tallinn");

moment.updateLocale("ru", {
    week: { dow: 1 },
});
moment.updateLocale("en", {
    week: { dow: 1 },
});
moment.updateLocale("et", {
    week: { dow: 1 },
});
moment.updateLocale("es", {
    week: { dow: 1 },
});

export const setMomentLocale = (lng: string) => {
    moment.locale(lng);
};

export default moment;
